module.exports = __webpack_public_path__ + "static/media/searchTalents.509d51d2.png";